import { NewGoalWithID, NewTagWithID } from '@griply/types';
import { defaultTagColorOption } from '@griply/utils';
import { useCallback, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const useNewEntities = () => {
  const [goalsToCreate, setGoalsToCreate] = useState<NewGoalWithID[]>([]);
  const [tagsToCreate, setTagsToCreate] = useState<NewTagWithID[]>([]);

  const onCreateGoal = useCallback(
    (name: string) =>
      setGoalsToCreate((prevGoals) => [
        ...prevGoals,
        {
          id: uuidv4(),
          name,
        },
      ]),
    [],
  );

  const onCreateTag = useCallback(
    (name: string) =>
      setTagsToCreate((prev) => [
        ...prev,
        {
          id: uuidv4(),
          name,
          color: defaultTagColorOption.value,
        },
      ]),
    [],
  );

  const resetEntities = useCallback(() => {
    setGoalsToCreate([]);
    setTagsToCreate([]);
  }, []);

  return {
    onCreateGoal,
    onCreateTag,
    goalsToCreate,
    tagsToCreate,
    resetEntities,
  };
};
